<template>
  <div>
    <div class="iframecontent" v-if="active == 0">
      <iframe
        :src="urlGeneral"
        height="100%"
        width="100%"
        class="iframe_style"
      />
    </div>
    <DeviceList v-if="active == 1" :home="true" />
    <AlarmList v-if="active == 2" />
    <div class="iframecontent" v-if="active == 3">
      <iframe
        :src="urlDeviceactionlog"
        height="100%"
        width="100%"
        class="iframe_style"
      />
    </div>
    <div class="topcode-wechat-home">
      <div class="header">
        <Tool />
        <Statistics />
      </div>
      <div class="content">
        <div class="menu-list">
          <MenuItem v-for="item in menuList" :key="item.id" :menu="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./style/index.less";
import Tool from "./components/Tool";
import Statistics from "./components/Statistics";
import MenuItem from "./components/MenuItem";
import DeviceList from "../../router/device/List";
import AlarmList from "../../router/alarm/List";
import { Button, Popup, Tabbar, TabbarItem } from "vant";
import storage from "@/utils/storage";
import * as UICOMPONENT from "@/utils/uicomponent";

export default {
  components: {
    Tool,
    Statistics,
    MenuItem,
    Popup,
    Button,
    Tabbar,
    TabbarItem,
    DeviceList,
    AlarmList,
  },
  props: {},
  data() {
    return {
      active: 4,
      urlGeneral: "",
      urlDeviceactionlog: "",
      ts: new Date().getTime(),
      menuList: [
        {
          id: 0,
          title: "扫一扫",
          img: require("./image/menu/scan.png"),
        },
        // {id: 1, to: '/map', title: '地图', img: require("./image/menu/map.png"),permiss:[]},
        {
          id: 2,
          to: "/device",
          title: "设备管理",
          img: require("./image/menu/device.png"),
          permiss: ["DEVICE_SHOW"],
        },
        {
          id: 3,
          to: "/device/install",
          title: "安装设备",
          img: require("./image/menu/install.png"),
          permiss: ["DEVICE_ADD"],
        },
        {
          id: 4,
          to: "/alarm",
          title: "告警管理",
          img: require("./image/menu/alarm.png"),
          permiss: ["ALARM_SHOW"],
        },
        {
          id: 5,
          to: "/order",
          title: "工单管理",
          img: require("./image/menu/order.png"),
          permiss: ["ORDER_TASK_SHOW"],
        },
        {
          id: 6,
          to: "/danger",
          title: "隐患排查",
          img: require("./image/menu/yinhuanpaicha.png"),
          permiss: ["SAFETY_DANGER_SHOW"],
        },
        {
          id: 7,
          to: "/prospect",
          title: "现场勘察",
          img: require("./image/menu/xianchangkancha.png"),
          permiss: ["PROSPECT_TASK_SHOW"],
        },
        {
          id: 8,
          to: "/safety",
          title: "安全打卡",
          img: require("./image/menu/anquandaka.png"),
          permiss: ["SAFETY_TASK_SHOW", "SAFETY_POSITION_SHOW"],
        },
        // {
        //     id: 10, to: '/linkage', title: '智能场景',
        //     img: require("./image/menu/linkage.png"),
        //     permiss: ['LINKAGE_SHOW']
        // },
        {
          id: 11,
          to: "/inspect",
          title: "巡检管理",
          img: require("./image/menu/inspect.png"),
          permiss: ["INSPECT_TASK_SHOW"],
        },
        {
          id: 12,
          to: "/pay",
          title: "服务费",
          img: require("./image/menu/servicePay.png"),
          permiss: ["PAY_DEVICE_SERVICE_CHARGE"],
        },
        {
          id: 13,
          to: "/snapshot",
          title: "随手拍",
          img: require("./image/menu/suishoupai.png"),
          permiss: [],
        },
        {
          id: 9,
          to: "/mime",
          title: "个人中心",
          img: require("./image/menu/gerenzhongxin.png"),
          permiss: [],
        },
      ],
    };
  },
  computed: {},
  created() {

  },
  mounted() {
    const openId = storage.getCache("openId");
    const { unitOrOrgan } = this.$default;
    this.$http.wechat.getAccessToken({ openId: openId }).then((res) => {
      if (res) {
        this.urlGeneral =
          UICOMPONENT.getUrl("GENERAL") +
          "//?token=bearer" +
          res.accessToken +
          "&unit_id=" +
          unitOrOrgan.id +
          "&ts=" +
          this.ts;
        this.urlDeviceactionlog =
          UICOMPONENT.getUrl("DEVICEACTIONLOG") +
          "//?token=bearer" +
          res.accessToken +
          "&unit_id=" +
          unitOrOrgan.id +
          "&ts=" +
          this.ts;
      }
    });
  },
  methods: {
    onChange(index) {
      this.active = index;
      this.$router.push("/");
    },
  },
  watch: {},
};
</script>

<style lang="less"></style>
